module.exports = __webpack_public_path__ + "img/word.ca1f3649.png";